import { ILog } from "@ihr-radioedit/inferno-core";
import {
  ihrCookieName,
  IHRServerSessionStateResolver,
  cookies,
  type IHeartUserProfile,
} from "@inferno/renderer-shared-core";
import { isLeft } from "fp-ts/lib/Either";

const log = ILog.logger("client/cookie_parser.ts");

export function getUserFromCookie() {
  try {
    const parsedCookie = cookies().getJSON<{ user: IHeartUserProfile }>(ihrCookieName);

    if (!parsedCookie) {
      log.debug("iheart-user cookie not found or invalid");
      return null;
    }

    const resolvedData = IHRServerSessionStateResolver.decode({
      profile: parsedCookie.user,
    });

    if (isLeft(resolvedData)) {
      log.error("Invalid cookie structure");
      return null;
    }

    return resolvedData.right;
  } catch (error) {
    log.error("Failed to parse iheart-user cookie", error);
    return null;
  }
}
